await themeComponent(theme.components['mc-btn'], false);
await themeComponent(theme.components['mc-element'], false);


class McPaginate extends McElement {
  connectedCallback() {
    this.target = this.parentElement;
    this.page = this.dataset.page;
    this.count = parseInt(this.dataset.skeletonCount || '8', 10);

    // Prefer an existing <button>; otherwise create one
    this.button = this.querySelector('a') || document.createElement('a');
    if (!this.button.isConnected) this.append(this.button);

    this.button.type = 'button';
    this.button.classList.add('paginate-btn');
    this.button.tabIndex = 0; // for safety if styled oddly

    this._onActivate = (e) => {
      // no preventDefault needed anymore
      e.stopPropagation?.();
      this.loadNext();
    };

    // One listener is enough; avoid pointerup/touchstart to prevent double fires
    this.button.addEventListener('click', this._onActivate);

    // Space/Enter already "click" a real <button>, no custom keydown needed

    this.loading = false;
    this.done = false;

    this._skeletonTemplate = this._buildSkeletonTemplate();
    this._skeletonNodes = [];
  }

  disconnect() {
    this.button?.removeEventListener('click', this._onActivate);
  }

  async loadNext() {
    if (this.loading || this.done) return;
    if (!this.page) return this.finish();

    this.loading = true;
    const wasDisabled = this.button.disabled;
    Promise.resolve().then(() => { this.button.disabled = true; });
    this.setAttribute('aria-busy', 'true');

    this._renderSkeletons();
    this.target.appendChild(this);

    try {
      const res = await fetch(this.page, { headers: { 'Accept': 'text/html' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const container = doc.querySelector('#' + this.target.id);
      if (!container) throw new Error('Container not found on next page');

      // Remove incoming pager (we’ll re-attach or finish below)
      const incomingPager = container.querySelector('mc-paginate');
      if (incomingPager) incomingPager.remove();

      const newCols = Array.from(container.children).filter(el => el.classList?.contains('col'));
      this._trimSkeletonsTo(newCols.length);
      this._removeSkeletons();

      const frag = document.createDocumentFragment();
      Array.from(container.children).forEach(node => {
        frag.appendChild(document.adoptNode ? document.adoptNode(node) : node);
      });
      this.target.appendChild(frag);

      this.closest('mc-collection')?._updateImageSizes?.();

      if (incomingPager) {
        this.remove();
        this.target.appendChild(incomingPager);
      } else {
        this.finish();
      }
    } catch (err) {
      console.error('Pagination load failed', err);
      this._removeSkeletons();
      this.button.disabled = wasDisabled;
      this.removeAttribute('aria-busy');
      this.loading = false;
      return;
    }

    this.loading = false;
    this.button.disabled = wasDisabled;
    this.removeAttribute('aria-busy');
  }

  finish() {
    this.done = true;
    this.button.disabled = true;
    this._removeSkeletons();
    this.remove();
  }

	_buildSkeletonTemplate() {
    const wrap = document.createElement('div');
    wrap.className = 'col mc-skel';
    wrap.setAttribute('data-skel', '1');
    wrap.innerHTML = `
      <div class="product-card">
        <div class="card-image">
          <span class="lazy__uncollapser"></span>
        </div>
        <div style="height: 102px"></div>
      </div>
    `;
    return wrap;
  }

  _renderSkeletons() {
    const frag = document.createDocumentFragment();
    this._skeletonNodes = [];
    const n = Math.max(0, this.count);

    for (let i = 0; i < n; i++) {
      const node = this._skeletonTemplate.cloneNode(true);
      this._skeletonNodes.push(node);
      frag.appendChild(node);
    }

    this.target.appendChild(frag);
  }

  _trimSkeletonsTo(n) {
    if (!this._skeletonNodes?.length) return;
    while (this._skeletonNodes.length > n) {
      const node = this._skeletonNodes.pop();
      node?.remove();
    }
  }

  _removeSkeletons() {
    if (this._skeletonNodes?.length) {
      this._skeletonNodes.forEach(n => n?.remove());
      this._skeletonNodes = [];
    }

    const stray = this.target.querySelectorAll('[data-skel="1"]');
    stray.forEach(el => el.remove());
  }


}

if (!window.customElements.get('mc-paginate')) {
  window.customElements.define('mc-paginate', McPaginate);
}
window.McPaginate = McPaginate;
